const STORAGE_KEY = 'gsq-breadcrumb-trail';
const MAX_AGE_MS = 30 * 60 * 1000;

/**
 * @param {string | undefined} raw
 * @returns {string[]}
 */
function parseCollectionHandles(raw) {
  if (!raw) return [];
  return raw.split(',').map((handle) => handle.trim()).filter(Boolean);
}

/**
 * @param {unknown} url
 * @returns {url is string}
 */
function isSafeShopPath(url) {
  return typeof url === 'string' && (url.startsWith('/') || url.startsWith(window.location.origin));
}

function saveTrailFromCollectionPage() {
  const nav = document.querySelector('.gsq-collection-breadcrumbs[data-trail]');
  if (!nav) return;

  const trailRaw = nav.dataset.trail;
  const handle = nav.dataset.collectionHandle;
  if (!trailRaw || !handle) return;

  try {
    const items = JSON.parse(trailRaw);
    if (!Array.isArray(items) || items.length === 0) return;

    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        handle,
        items,
        savedAt: Date.now(),
      })
    );
  } catch {
    // Ignore malformed trail data.
  }
}

class GsqProductBreadcrumbs extends HTMLElement {
  connectedCallback() {
    if (!this.classList.contains('gsq-product-breadcrumbs--client')) return;
    this.#hydrateFromSession();
  }

  #hydrateFromSession() {
    const list = this.querySelector('.gsq-product-breadcrumbs__list');
    if (!list) return;

    const allowedHandles = parseCollectionHandles(this.dataset.productCollections);
    const storedRaw = sessionStorage.getItem(STORAGE_KEY);
    if (!storedRaw) return;

    try {
      const { handle, items, savedAt } = JSON.parse(storedRaw);
      if (!handle || !Array.isArray(items) || items.length === 0) return;
      if (Date.now() - savedAt > MAX_AGE_MS) return;
      if (!allowedHandles.includes(handle)) return;
      if (!items.every((item) => item?.title && isSafeShopPath(item.url))) return;

      list.replaceChildren(
        ...items.map((item) => {
          const li = document.createElement('li');
          li.className = 'gsq-product-breadcrumbs__item';

          const link = document.createElement('a');
          link.className = 'gsq-product-breadcrumbs__link';
          link.href = item.url;
          link.textContent = item.title;
          li.appendChild(link);
          return li;
        })
      );

      this.hidden = false;
    } catch {
      // Keep hidden when storage is invalid.
    }
  }
}

if (!customElements.get('gsq-product-breadcrumbs')) {
  customElements.define('gsq-product-breadcrumbs', GsqProductBreadcrumbs);
}

saveTrailFromCollectionPage();
